import { useRef, useState } from 'react';
import useDialogFocus from '../../hooks/useDialogFocus';

/** Reword one note. `onSave(text)` does the work; `error` is shown above the buttons. */
const NoteEditModal = ({ entry, onSave, onClose, busy, error }) => {
  const dialogRef = useRef(null);
  useDialogFocus(dialogRef);
  const [note, setNote] = useState(entry.note || '');
  const empty = !note.trim();

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!empty) onSave(note.trim());
  };

  return (
    <div
      ref={dialogRef}
      className="modal show d-block"
      tabIndex="-1"
      role="dialog"
      aria-modal="true"
      aria-labelledby="noteEditTitle"
      style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}
    >
      <div className="modal-dialog">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title" id="noteEditTitle">
              <i className="bi bi-pencil me-2"></i>
              Edit note
            </h5>
            <button type="button" className="btn-close" onClick={onClose} disabled={busy} aria-label="Close"></button>
          </div>
          <form onSubmit={handleSubmit}>
            <div className="modal-body">
              <label htmlFor="noteEditText" className="form-label">Note</label>
              <textarea
                id="noteEditText"
                className="form-control"
                rows="3"
                maxLength={1000}
                value={note}
                onChange={(e) => setNote(e.target.value)}
                disabled={busy}
              />
              <div className="form-text">
                The employee sees the new wording. The old wording stays in the history for approvers.
              </div>
              {error && (
                <div className="alert alert-danger mt-3 mb-0" role="alert">
                  {error}
                </div>
              )}
            </div>
            <div className="modal-footer">
              <button type="button" className="btn btn-secondary" onClick={onClose} disabled={busy}>
                Cancel
              </button>
              <button type="submit" className="btn btn-primary" disabled={busy || empty}>
                {busy ? 'Saving…' : 'Save note'}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default NoteEditModal;
